import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, Sparkles } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../App";

export function PaymentSuccess() {
  const { lang } = useLang();
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    let tries = 0;
    const poll = async () => {
      if (!sessionId) { setStatus("error"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
      } catch (e) {}
      if (++tries < 8) setTimeout(poll, 2000); else setStatus("pending");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="max-w-lg text-center">
        {status === "checking" && <><Loader2 className="animate-spin mx-auto text-[#D4AF37]" size={48} /><p className="mt-6 text-[#64748B]">{lang === "pl" ? "Potwierdzamy płatność..." : "Confirming payment..."}</p></>}
        {status === "paid" && <>
          <CheckCircle2 className="mx-auto text-[#D4AF37]" size={64} />
          <h1 className="font-display text-4xl sm:text-5xl mt-6">{lang === "pl" ? "Dziękujemy!" : "Thank you!"}</h1>
          <p className="mt-4 text-[#1A243A]/80 leading-relaxed">{lang === "pl" ? "Twoje zamówienie zostało przyjęte. Wkrótce skontaktujemy się z Tobą, aby bezpiecznie odebrać zdjęcia i rozpocząć tworzenie wyjątkowej książki." : "Your order was received. We'll contact you shortly to securely collect photos and begin crafting your unique book."}</p>
          <Sparkles className="mx-auto text-[#B79CE8] mt-6" size={28} />
        </>}
        {(status === "pending" || status === "error") && <>
          <p className="mt-6 text-[#64748B]">{lang === "pl" ? "Płatność jest przetwarzana. Sprawdź e-mail lub odśwież stronę za chwilę." : "Payment is processing. Check your email or refresh shortly."}</p>
        </>}
        <div className="mt-10"><Link to="/" data-testid="back-home" className="inline-block rounded-full px-8 py-3 bg-[#1A243A] text-[#FDFBF7] font-semibold hover:bg-[#D4AF37] hover:text-[#1A243A] transition-colors">{lang === "pl" ? "Wróć na stronę główną" : "Back to home"}</Link></div>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const { lang } = useLang();
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="max-w-lg text-center">
        <XCircle className="mx-auto text-[#64748B]" size={64} />
        <h1 className="font-display text-4xl mt-6">{lang === "pl" ? "Płatność anulowana" : "Payment cancelled"}</h1>
        <p className="mt-4 text-[#64748B]">{lang === "pl" ? "Nic nie zostało pobrane. Możesz spróbować ponownie w dowolnej chwili." : "Nothing was charged. You can try again anytime."}</p>
        <div className="mt-10"><Link to="/" className="inline-block rounded-full px-8 py-3 bg-[#1A243A] text-[#FDFBF7] font-semibold hover:bg-[#D4AF37] hover:text-[#1A243A] transition-colors">{lang === "pl" ? "Wróć" : "Back"}</Link></div>
      </div>
    </div>
  );
}
